import { createContext } from 'react';
import type { AppTheme } from '../utils/appTheme';

export interface AppThemeContextValue {
  theme: AppTheme;
  setTheme: (theme: AppTheme) => void;
}

export const AppThemeContext = createContext<AppThemeContextValue | null>(null);
